import React, { useEffect, useContext, useState } from 'react'
import '../assets/widget-icon.scss'
import { DashboardContext } from 'live/context/dashboard'
import { Wrapper, WrapperComponent } from './StandardTableStyles'

const StandardTable = (props: ChartMessageTableProps): JSX.Element => {
    const [matrixOrdered, setMatrixOrdered] = useState([])
    const [templateRow, setTemplateRow] = useState('1f')
    const [templateCol, setTemplateCol] = useState('1f')
    const [templateAreas, setTemplateAreas] = useState('')
    const { ...context } = useContext(DashboardContext)

    useEffect(() => {
        if (props?.values && props.values.length > 0) {
            let matrix = [],
                cols = props?.values.length,
                rows = 1,
                className = 'els',
                templateCol = ''

            props.values.map((col, colIdx) => {
                templateCol += '1fr' + (colIdx === cols - 1 ? '' : ' ')
                if (col.length > rows) rows = col.length
                col.map((row, rowIdx) => {
                    matrix.push({
                        label: row.label.toUpperCase(),
                        value: row.value,
                        span: row.uom,
                        className: `${className}-${rowIdx}-${colIdx}`
                    })
                })
            })

            let templateRow = '',
                templateAreas = ``
            for (let row = 0; row < rows; row++) {
                templateRow += '1fr' + (row === rows - 1 ? '' : ' ')
                templateAreas += `"`
                for (let col = 0; col < cols; col++) {
                    templateAreas += `${className}-${row}-${
                        col +
                        (col === cols - 1
                            ? `"` +
                              (row !== rows - 1
                                  ? `
`
                                  : '')
                            : ' ')
                    }`
                }
            }

            setTemplateAreas(templateAreas)
            setTemplateCol(templateCol)
            setTemplateRow(templateRow)
            setMatrixOrdered(matrix)
        }
    }, [JSON.stringify(props.values)])

    if (matrixOrdered.length === 0) return <Wrapper>No data info available yet</Wrapper>

    return (
        <WrapperComponent>
            <Wrapper
                templateCol={templateCol}
                templateRow={templateRow}
                templateAreas={templateAreas}
                theme={context.theme}
            >
                {matrixOrdered.map((e, i) => (
                    <div key={i} className={e.className} style={{ gridArea: e.className }}>
                        <h3>{e.label}</h3>
                        <p>
                            {e.value}
                            <span>{e.span}</span>
                        </p>
                    </div>
                ))}
            </Wrapper>
        </WrapperComponent>
    )
}

export default StandardTable
